import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-router-link',
	templateUrl:'./RouterLinkPluginCompPage.html',
	styles: [],
	styleUrls:['./RouterLinkPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class RouterLinkPluginCompPage
{
	mdContent_1096 = `\`\`\`java
import com.jwebmp.core.angular.components.RouterLink;
\`\`\``;
	mdContent_1097 = `\`\`\`java
new RouterLink()
\`\`\``;
}
